import client from "./client";
export const getConversations = () => client.get("/dm/conversations");
export const getMessagesWith = (userId) => client.get(`/dm/with/${userId}`);
export const sendMessageTo = (userId, content) => client.post(`/dm/to/${userId}`, { content });
export const sendApplicationFeedback = (applicationId, content) => client.post(`/dm/feedback/${applicationId}`, { content });
export const markAllDmRead = () => client.put("/dm/read-all");
